/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';

import { params } from '../../../../../redux/reducers/reducer';
import { convertFeet } from '../../../../../utils/ConvertFeet';

import LineModel from '../../LineModel';
import DimensionValue from '../../DimensionValue';

const FrontLeanToMeasurement = ({ color }) => {
    const frontLeftPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.lean_p_w) < 9) {
            if((params.leanF_p_pos - params.leanF_p_d / 2 - 2.5 < -params.p_w / 2 - 1) && (params.lean_p_pos + params.lean_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.lean_p_pos, params.lean_p_d, params.p_d, params.leanF_p_w, params.lean_p_w])

    const frontRightPosState = useMemo(() => {
        let offset = false;
        if((params.leanF_p_w && params.leanR_p_w) < 9) {
            if((params.leanF_p_pos + params.leanF_p_d / 2 + 2.5 > params.p_w / 2 + 1) && (params.leanR_p_pos + params.leanR_p_d / 2 + 2.5 > params.p_d / 2 + 1)){
                offset = true;
            }
        }
        
        return offset;
    }, [params.leanF_p_pos, params.leanF_p_d, params.p_w, params.leanR_p_pos, params.leanR_p_d, params.p_d, params.leanF_p_w, params.leanR_p_w])

    const [arrowInfosData, setArrowInfosData] = useState({
        lengthArrowSize: 0,
        lengthArrowPos: [0, 0, 0],
        widthArrowSize: 0,
        leftWidthArrowPos: [0, 0, 0],
        rightWidthArrowPos: [0, 0, 0],
        heightArrowSize: 0,
        leftHeightArrowPos: [0, 0, 0],
        rightHeightArrowPos: [0, 0, 0],
    });

    const arrowOffset = 0.3;
    const offset = 0.2;

    useMemo(() => {
        const {
            leanF_p_d, leanF_p_w, leanF_p_h, lean_p_w, leanR_p_w,
            add_left_front_lean_porch, add_right_front_lean_porch, p_d, leanF_p_pos,
        } = params;
        const alignPosOffset = 0;
        let newArrowPositions = {};

        if (add_left_front_lean_porch && !add_right_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: leanF_p_d + lean_p_w + 0.4,
                lengthArrowPos: [-lean_p_w / 2 + alignPosOffset, offset, p_d / 2 + leanF_p_w + arrowOffset],
                widthArrowSize: leanF_p_w,
                leftWidthArrowPos: [-(leanF_p_d / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                rightWidthArrowPos: [(leanF_p_d / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                heightArrowSize: leanF_p_h,
                leftHeightArrowPos: [-(leanF_p_d / 2 + offset + lean_p_w) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
                rightHeightArrowPos: [(leanF_p_d / 2 + offset) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
            };
        } else if (!add_left_front_lean_porch && add_right_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: leanF_p_d + leanR_p_w + 0.4,
                lengthArrowPos: [leanR_p_w / 2 + alignPosOffset, offset, p_d / 2 + leanF_p_w + arrowOffset],
                widthArrowSize: leanF_p_w,
                leftWidthArrowPos: [-(leanF_p_d / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                rightWidthArrowPos: [(leanF_p_d / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                heightArrowSize: leanF_p_h,
                leftHeightArrowPos: [-(leanF_p_d / 2 + offset) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
                rightHeightArrowPos: [(leanF_p_d / 2 + leanR_p_w + offset) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
            };
        } else if (add_left_front_lean_porch && add_right_front_lean_porch) {
            newArrowPositions = {
                lengthArrowSize: leanF_p_d + lean_p_w + leanR_p_w + 0.4,
                lengthArrowPos: [0, offset, p_d / 2 + leanF_p_w + arrowOffset],
                widthArrowSize: leanF_p_w,
                leftWidthArrowPos: [-(leanF_p_d / 2 + offset), 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                rightWidthArrowPos: [(leanF_p_d / 2) + offset, 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                heightArrowSize: leanF_p_h,
                leftHeightArrowPos: [-(leanF_p_d / 2 + lean_p_w + offset), leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
                rightHeightArrowPos: [(leanF_p_d / 2 + leanR_p_w + offset), leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
            };
        } else {
            newArrowPositions = {
                lengthArrowSize: leanF_p_d + 0.4,
                lengthArrowPos: [0 + alignPosOffset, arrowOffset - 0.1, p_d / 2 + leanF_p_w + arrowOffset],
                widthArrowSize: leanF_p_w,
                leftWidthArrowPos: [-(leanF_p_d / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                rightWidthArrowPos: [(leanF_p_d / 2 + offset) + alignPosOffset, 0, p_d / 2 + leanF_p_w / 2 + arrowOffset],
                heightArrowSize: leanF_p_h,
                leftHeightArrowPos: [-(leanF_p_d / 2 + offset) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
                rightHeightArrowPos: [(leanF_p_d / 2 + offset) + alignPosOffset, leanF_p_h / 2, p_d / 2 + leanF_p_w + arrowOffset],
            };
        }

        setArrowInfosData(newArrowPositions);
    }, [
        params.p_w, params.p_d, params.leanF_p_w, params.leanF_p_d, params.leanF_p_h,
        params.leanF_p_pos, params.add_left_front_lean_porch, params.add_right_front_lean_porch, params.leantoAlignmentFront,
    ]);

    const { 
        lengthArrowSize, lengthArrowPos, widthArrowSize, 
        leftWidthArrowPos, rightWidthArrowPos, heightArrowSize, 
        leftHeightArrowPos, rightHeightArrowPos 
    } = arrowInfosData;


    return params.add_front_lean && (
        <group name='Measurements-frontLeanto'>
            {/* length */}
            <group name='front-arrow' position={lengthArrowPos}>
                <LineModel length={lengthArrowSize} rotation={[0, 0, Math.PI / 2]} color={color} />
                <DimensionValue position={[0, -0.2, 0.4]} rotation={[0, 0, 0]} value={`${convertFeet((lengthArrowSize-0.4),false)} L`} slopeAngle={25} type={'lean'} cmpPos={lengthArrowPos} />
            </group>

            {/* width */}
            <group name='left-arrow' position={leftWidthArrowPos}>
                <LineModel length={widthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[frontLeftPosState ? -0.1: -0.4, frontLeftPosState ? 1.5 : 0, 0]} rotation={[0, -Math.PI / 2, 0]} value={`${convertFeet(widthArrowSize,false)} W`} slopeAngle={frontLeftPosState ? 0 : 25} type={'lean'} cmpPos={leftWidthArrowPos} />
            </group>
            <group name='right-arrow' position={rightWidthArrowPos}>
                <LineModel length={widthArrowSize} position={[0, 0.2, 0]} rotation={[Math.PI / 2, 0, 0]} color={color} />
                <DimensionValue position={[frontRightPosState ? 0.1 : 0.4, frontRightPosState ? 1.5 : 0, 0]} rotation={[0, Math.PI / 2, 0]} value={`${convertFeet(widthArrowSize,false)} W`} slopeAngle={frontRightPosState ? 0 : 25} type={'lean'} cmpPos={rightWidthArrowPos} />
            </group>

            {/* height */}
            <group name='left-arrow' position={leftHeightArrowPos}>
                <LineModel length={heightArrowSize - 0.2} color={color} position={[0, 0.08, 0]} />
                {!params.add_left_front_lean_porch && (
                    <DimensionValue position={[-[...`${convertFeet(heightArrowSize)} H`].length * 0.2, 0, -offset]} rotation={[0, 0, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={leftHeightArrowPos} />
                )}
            </group>
            <group name='right-arrow' position={rightHeightArrowPos} rotation={[0, -Math.PI / 2, 0]}>
                <LineModel length={heightArrowSize - 0.2} color={color} position={[0, 0.08, 0]} />
                {!params.add_right_front_lean_porch && (
                    <DimensionValue position={[[...`${convertFeet(heightArrowSize)} H`].length * 0.2, 0, -offset]} rotation={[0, 0, 0]} value={`${convertFeet(heightArrowSize,false)} H`} slopeAngle={0} type={'lean'} checkBackSide={true} cmpPos={rightHeightArrowPos}/>
                )}
            </group>
        </group>
    );
};

export default FrontLeanToMeasurement;
